import { FORM_CODES } from 'insurers/royalLondon'
import * as reports from './reports'

export default () => {

    const getReportByCode = (formCode) => {

        // Get object containing the reports for the form code specified
        const report = ({
            [FORM_CODES.pmar]: reports.Pmar,
            [FORM_CODES.mir]: reports.MissingInformation,
            [FORM_CODES.cancer]: reports.Cancer,
            [FORM_CODES.cardiovascular]: reports.Cardiovascular,
            [FORM_CODES.mentalHealth]: reports.MentalHealth,
            [FORM_CODES.stroke]: reports.Stroke,
            [FORM_CODES.multipleSclerosis]: reports.MultipleSclerosis,
            [FORM_CODES.heartDisease]: reports.HeartDisease,
            [FORM_CODES.heartDisorder]: reports.HeartDisorder,
            [FORM_CODES.hepatitis]: reports.Hepatitis,
            [FORM_CODES.kidney]: reports.Kidney,
            [FORM_CODES.respiratory]: reports.Respiratory,
            [FORM_CODES.diabetes]: reports.Diabetes,
            [FORM_CODES.tgcm]: reports.Tgcm,
            [FORM_CODES.neurological]: reports.Neurological,
            [FORM_CODES.liver]: reports.Liver,
            [FORM_CODES.prostate]: reports.Prostate,
            [FORM_CODES.gastro]: reports.Gastro,
            [FORM_CODES.alcohol]: reports.Alcohol,
            [FORM_CODES.musculoskeletal]: reports.Musculoskeletal,
            [FORM_CODES.eatingDisorder]: reports.EatingDisorder
        })[formCode]

        return report
    }

    return {
        getReportByCode
    }
}